import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { FetchGradingSchemeByModuleIdSuccess } from 'app/library/grading-scheme/actions/fetch-grading-scheme-by-module-id-success.action';
import { IActionWithPayload } from 'app/projects/core/src/lib/interfaces/action_with_payload.interface';
import { IEntityState } from 'app/projects/entity/src/lib/interfaces/entity.state.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { EntityState } from 'app/projects/entity/src/lib/models/entity.state';
import {
    AddGradingSchemes,
    CreateGradingScheme,
    DeleteGradingScheme,
    FetchGradingScheme,
    FetchGradingSchemes,
    FetchGradingSchemesFailure,
    FetchGradingSchemesSuccess,
    SetGradingScheme,
    SetGradingSchemes,
    UnsetGradingScheme,
    UpdateGradingScheme,
} from '../actions';
import { FetchGradingSchemeByModuleIdDone } from '../actions/fetch-grading-scheme-by-module-id-done.action';
import { FetchGradingSchemeByModuleIdFailure } from '../actions/fetch-grading-scheme-by-module-id-failure.action';
import { FetchGradingSchemeByModuleId } from '../actions/fetch-grading-scheme-by-module-id.action';
import { SetGradingSchemeToModuleFailure } from '../actions/set-grading-scheme-to-module-failure.action';
import { SetGradingSchemeToModuleSuccess } from '../actions/set-grading-scheme-to-module-success.action';
import { SetGradingSchemeToModule } from '../actions/set-grading-scheme-to-module.action';
import { UnsetGradingSchemeFromModuleFailure } from '../actions/unset-grading-scheme-from-module-failure.action';
import { UnsetGradingSchemeFromModuleSuccess } from '../actions/unset-grading-scheme-from-module-success.action';
import { UnsetGradingSchemeFromModule } from '../actions/unset-grading-scheme-from-module.action';
import { UpdateGradeCalculationFailure } from '../actions/update-grade-calculation-failure.action';
import { UpdateGradeCalculationSuccess } from '../actions/update-grade-calculation-success.action';
import { UpdateGradeCalculation } from '../actions/update-grade-calculation.action';
import { GradingSchemeApiService } from '../services/grading-scheme.api-service';
import { GradingScheme } from './grading-scheme.model';
import { GradingSchemeStateModel } from './grading-scheme.state-model';

@State<GradingSchemeStateModel>({
    name: 'gradingScheme',
    defaults: new GradingSchemeStateModel(),
})
@Injectable()
export class GradingSchemeState extends EntityState<GradingScheme> implements IEntityState<GradingScheme> {
    @Selector()
    static getEntity(state: GradingSchemeStateModel, id: string = state.item): GradingScheme {
        if (!state.map) {
            return null;
        }

        return state.map.get(id) || null;
    }

    @Selector()
    static getEntities(state: GradingSchemeStateModel): GradingScheme[] {
        if (!state.map) {
            return null;
        }

        return Array.from(state.map.values());
    }

    constructor(private _gradingSchemeService: GradingSchemeApiService, private _store: Store) {
        super(_gradingSchemeService, 0);

        this._propstoSearch = GradingScheme.props_to_search;
    }
    @Action(AddGradingSchemes)
    addEntities(ctx: StateContext<GradingSchemeStateModel>, action: AddGradingSchemes): void {
        this._addEntities(ctx, action);
    }

    @Action(SetGradingScheme)
    setEntity(ctx: StateContext<GradingSchemeStateModel>, action: SetGradingScheme): void {
        this._setEntity(ctx, action, AddGradingSchemes);
    }

    @Action(UnsetGradingScheme)
    unsetEntity(ctx: StateContext<GradingSchemeStateModel>): void {
        this._unsetEntity(ctx);
    }

    createEntity(state: StateContext<GradingSchemeStateModel>, action: IActionWithPayload<GradingScheme>): void {
        throw new Error('Method not implemented.');
    }

    @Action(CreateGradingScheme)
    createEntityWithDifferentPayload(ctx: StateContext<GradingSchemeStateModel>, action: CreateGradingScheme): void {
        throw new Error('Method not implemented.');
    }

    @Action(UpdateGradingScheme)
    updateEntity(ctx: StateContext<GradingSchemeStateModel>, action: UpdateGradingScheme): void {
        throw new Error('Method not implemented.');
    }

    @Action(DeleteGradingScheme)
    deleteEntity(ctx: StateContext<GradingSchemeStateModel>, action: DeleteGradingScheme): void {
        throw new Error('Method not implemented.');
    }

    @Action(FetchGradingScheme)
    fetchEntity(ctx: StateContext<GradingSchemeStateModel>, action: FetchGradingScheme): void {
        throw new Error('Method not implemented.');
    }

    fetchEntitySuccess(state: StateContext<GradingSchemeStateModel>, action: IActionWithPayload<GradingScheme>): void {
        throw new Error('Method not implemented.');
    }

    fetchEntityFailure(state: StateContext<GradingSchemeStateModel>, action: IActionWithPayload<IFetchEntityFailureActionPayload>): void {
        throw new Error('Method not implemented.');
    }

    @Action(SetGradingSchemes)
    setEntities(ctx: StateContext<GradingSchemeStateModel>, action: SetGradingSchemes): void {
        this._setEntities(ctx, action);
    }

    @Action(FetchGradingSchemes)
    fetchEntities(ctx: StateContext<GradingSchemeStateModel>): void {
        this._fetchEntities(ctx, FetchGradingSchemesSuccess, FetchGradingSchemesFailure, SetGradingSchemes, this._gradingSchemeService.getAll()).then(() => {});
    }

    @Action(FetchGradingSchemesSuccess)
    fetchEntitiesSuccess(ctx: StateContext<GradingSchemeStateModel>): void {
        this._fetchEntitiesSuccess(ctx);
    }

    @Action(FetchGradingSchemesFailure)
    fetchEntitiesFailure(ctx: StateContext<GradingSchemeStateModel>): void {
        this._fetchEntitiesFailure(ctx);
    }

    @Action(FetchGradingSchemeByModuleId)
    fetchGradingSchemeByModuleId({ dispatch }: StateContext<GradingSchemeStateModel>, { payload }: FetchGradingSchemeByModuleId): void {
        this._gradingSchemeService.fetchGradingSchemeByModuleId(payload.moduleId).subscribe(
            (entity) => {
                if (entity) {
                    dispatch([new SetGradingScheme(entity), new FetchGradingSchemeByModuleIdSuccess({ gradingScheme: entity }), new FetchGradingSchemeByModuleIdDone()]);
                } else {
                    dispatch([new UnsetGradingScheme(), new FetchGradingSchemeByModuleIdSuccess({ gradingScheme: entity }), new FetchGradingSchemeByModuleIdDone()]);
                }
            },
            (response: HttpErrorResponse) => {
                dispatch([new FetchGradingSchemeByModuleIdFailure(), new FetchGradingSchemeByModuleIdDone()]);
            }
        );
    }

    @Action(SetGradingSchemeToModule)
    setGradingSchemeToModule({ dispatch }: StateContext<GradingSchemeStateModel>, { payload }: SetGradingSchemeToModule): void {
        this._gradingSchemeService.setGradingSchemeToModule(payload).subscribe(
            (entity) => {
                dispatch([new SetGradingScheme(entity), new SetGradingSchemeToModuleSuccess({ gradingScheme: entity })]);
            },
            (response: HttpErrorResponse) => {
                dispatch(new SetGradingSchemeToModuleFailure());
            }
        );
    }

    @Action(UpdateGradeCalculation)
    updateGradeCalculation({ dispatch, getState }: StateContext<GradingSchemeStateModel>, { payload }: UpdateGradeCalculation): void {
        this._gradingSchemeService.updateGradeCalculation(payload.moduleId, payload.value).subscribe(
            (entity) => {
                dispatch([new SetGradingScheme(entity), new UpdateGradeCalculationSuccess({ gradingScheme: entity })]);
            },
            (response: HttpErrorResponse) => {
                dispatch(new UpdateGradeCalculationFailure());
            }
        );
    }

    @Action(UnsetGradingSchemeFromModule)
    unsetGradingSchemeFromModule({ dispatch }: StateContext<GradingSchemeStateModel>, { payload }: UnsetGradingSchemeFromModule): void {
        this._gradingSchemeService.unsetGradingSchemeFromModule(payload.moduleId).subscribe(
            () => {
                dispatch(new UnsetGradingSchemeFromModuleSuccess());
            },
            (response: HttpErrorResponse) => {
                dispatch(new UnsetGradingSchemeFromModuleFailure());
            }
        );
    }
}
